import SidebarIcon from '@/components/atoms/SidebarIcon';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';

const USER_LINKS = [
  { iconKey: 'dashboard', path: 'dashboard' },
  { iconKey: 'budget', path: 'budgets' },
  { iconKey: 'invoice', path: 'invoice' },
  { iconKey: 'commitment', path: 'commitment' },
  { iconKey: 'profile', path: 'profile' }
];

const ADMIN_LINKS = [
  { iconKey: 'dashboard', path: 'admin/dashboard' },
  { iconKey: 'subscriber', path: 'admin/subscribers' }
];

const MobileBottonNavigation = () => {
  const [activeLink, setActiveLink] = useState('');
  const navigate = useNavigate();
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  useEffect(() => {
    const currentPath = window.location.pathname.split('/')[1];
    setActiveLink(currentPath || 'dashboard');
  }, []);

  const handleNavigation = (path: string) => {
    setActiveLink(path);
    navigate(`/${path}`);
  };

  const isAdmin = currentUser?.roles?.includes('ADMIN');
  const links = isAdmin ? ADMIN_LINKS : USER_LINKS;

  const isLinkActive = (linkPath: string) => {
    const currentPath = window.location.pathname.slice(1);
    return currentPath === linkPath || currentPath.startsWith(linkPath + '/');
  };

  return (
    <nav className={`flex items-center w-full ${isAdmin ? 'justify-center gap-8' : 'justify-between'}`}>
      {links.map((link) => (
        <button key={link.path} className="relative" onClick={() => handleNavigation(link.path)} type="button">
          <SidebarIcon iconKey={link.iconKey} isActive={isLinkActive(link.path)} />
          {isLinkActive(link.path) && (
            <span className="absolute h-[4px] w-[4px] bg-white rounded-full left-[50%] translate-x-[-50%] bottom-[-14px]"></span>
          )}
        </button>
      ))}
    </nav>
  );
};

export default MobileBottonNavigation;
